import { apiFetch } from "../useApi";

export default async function deleteCampaign({ campaignId }) {
  const response = await apiFetch(`/campaigns/${campaignId}`, {
    method: 'DELETE',
  });
}
